import { formatCurrency } from "web_myplann/Infrastructure/Utils/CurrencyUtils";
import { CurrencyCode } from "web_myplann/Shared/constants";

export const INSPIRATION_CURRENCY = CurrencyCode.CZK;

export const formatInspirationMoney = (value: number): string =>
	formatCurrency(value, INSPIRATION_CURRENCY, 0);
